import React from 'react';
import { StyledAuthorizationLayout } from './styles';

const AuthorizationLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => <StyledAuthorizationLayout>{children}</StyledAuthorizationLayout>;

export default React.memo(AuthorizationLayout);
